export default __webpack_public_path__ + "static/media/RecipesMockupSmall.e6f1e0af.png";